export const trimObject = (obj: Object) => {
  const trimmedEntries = Object.entries(obj).map(([k, v]) =>
    typeof v === "string" ? [k, v.trim()] : [k, v]
  );

  return Object.fromEntries(trimmedEntries);
};
